import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import useIcons from '@/composables/useIcons'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MaintenanceBanner',
  setup(__props) {

  const { warning } = useIcons()

  const maintenanceBannerTitle = computed(() => process.env.VUE_APP_MAINTENANCE_BANNER_TITLE)

  const maintenanceBannerDescription = computed(() => process.env.VUE_APP_MAINTENANCE_BANNER_DESCRIPTION)

return { __sfc: true,warning, maintenanceBannerTitle, maintenanceBannerDescription, computed, useIcons, SVGRenderer }
}

})